// extracted by mini-css-extract-plugin
export default {"dbCard":"xzqOR","addCard":"Ujluu"};